module.exports = __webpack_public_path__ + "img/icn_school_off.a6bbf675.svg";